export default __webpack_public_path__ + "static/media/indogo-screenshot-04.c32e0cf5.png";